import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';

import { SideNavFooterService } from './side-nav-footer.service';

@Component({
  selector: 'iss-side-nav-footer',
  templateUrl: './side-nav-footer.component.html',
  styleUrls: [ './side-nav-footer.component.scss' ],
  standalone: true,
  imports: [ NgIf, NgTemplateOutlet ],
})
export class SideNavFooterComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly service = inject(SideNavFooterService);
  private readonly cdr = inject(ChangeDetectorRef);
  public template: TemplateRef<unknown> | null = null;

  public ngOnInit(): void {
    this.service.template$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(template => {
      this.template = template;
      this.cdr.markForCheck();
    });
  }
}
